module.exports = __webpack_public_path__ + "img/Beerscovery_Logo_Isolated_DRKBLUE.4e2efc74.png";